import ShiftCode from "@/components/shift/ShiftCode";
import { Check } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/utils/cn";

type RosterModifyShift = {
  readonly shift_id: string;
  readonly name: string;
  readonly color: string;
};

export function RosterModifyShiftButton({
  shift,
  isSelected,
  onSelect,
  disabled = false,
}: {
  shift: RosterModifyShift;
  isSelected: boolean;
  onSelect: () => void;
  disabled?: boolean;
}) {
  const name = shift.name?.trim() || shift.shift_id;
  const label =
    name === shift.shift_id ? shift.shift_id : `${name} (${shift.shift_id})`;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          disabled={disabled}
          className={cn(
            "button_inputShiftCode relative",
            isSelected && "selected",
            disabled && "cursor-not-allowed opacity-50"
          )}
          title={label}
          aria-label={label}
          aria-pressed={isSelected}
          onClick={onSelect}
        >
          <ShiftCode code={shift.shift_id} color={shift.color} />
          {isSelected && (
            <span
              className="pointer-events-none absolute -right-1.5 -top-1.5 flex size-5 items-center justify-center rounded-full border-2 border-white bg-[#0E59C6] text-white shadow-sm"
              aria-hidden="true"
            >
              <Check size={12} strokeWidth={3} />
            </span>
          )}
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        className="bg-foreground text-background"
        arrowClassName="fill-foreground"
      >
        <div className="flex flex-col gap-0.5 whitespace-nowrap">
          <span className="font-semibold">{name}</span>
          {name !== shift.shift_id && (
            <span className="text-[11px] text-background/70">
              코드 {shift.shift_id}
            </span>
          )}
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
